import { render, staticRenderFns } from "./OTPInputComponent.vue?vue&type=template&id=7ad5487c"
import script from "./OTPInputComponent.vue?vue&type=script&lang=js"
export * from "./OTPInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports